import { FC } from 'react';

import { CopyableText, DescriptionBlock } from '@/common/components';
import { BaseQueryParams } from '@/common/interfaces';
import { CommonDrawerTitle } from '@/common/layouts';

import { useGetByIdReferralsQuery } from '@/modules/Sites';

import { ReferralsOverviewDropdown } from './ReferralsOverviewDropdown';

interface Props {
  referral: BaseQueryParams<typeof useGetByIdReferralsQuery>['data'];
  disableButtons: boolean;
  isDeleteReferralLoading: boolean;
  handleEditReferral: () => void;
  handleDeleteReferral: () => void;
}

export const ReferralsOverviewView: FC<Props> = ({
  referral,
  disableButtons,
  isDeleteReferralLoading,
  handleEditReferral,
  handleDeleteReferral
}) => {
  return (
    <>
      <CommonDrawerTitle
        onlyExtra
        extra={
          <ReferralsOverviewDropdown
            isItemsDisabled={ disableButtons }
            isDeleteReferralLoading={ isDeleteReferralLoading }
            handleEditReferral={ handleEditReferral }
            handleDeleteReferral={ handleDeleteReferral }
          />
        }
      />

      <DescriptionBlock items={ [['Назва', <CopyableText key="referral.name" textToCopy={ referral.name }>{ referral.name }</CopyableText>]] }/>
      <DescriptionBlock items={ [['Slug', <CopyableText key="referral.slug" textToCopy={ referral.slug }>{ referral.slug }</CopyableText>]] }/>
    </>
  );
};
